import './style.scss';
import './editor.scss';

import Swiper from 'swiper/bundle';

document.addEventListener( 'DOMContentLoaded', function () {
	// import Swiper JS
	const carousels = document.querySelectorAll( '.swiper__home_boxes_swiper' );
	if ( carousels ) {
		carousels.forEach( ( carousel ) => {
			const id = carousel.id;
			if ( id ) {
				const nextButton = carousel.querySelector(
					'.swiper-button-next'
				);
				const prevButton = carousel.querySelector(
					'.swiper-button-prev'
				);
				const paginator =
					carousel.querySelector( '.swiper-pagination' );
					const perviewSlider = carousel.getAttribute( 'data-perview' );

				const swiperCarousel = new Swiper( `#${ id }`, {
					// Optional parameters
					centeredSlides: false, 
    				loop: true,
					grabCursor: true,
					spaceBetween: 0,
					direction: 'vertical',
					slideToClickedSlide: true,
					slidesPerView: 1.6,

					// Rotation
					// autoplay: {
					// 	delay: 7000,
					// 	disableOnInteraction: false,
					// },

					// Navigation arrows
					navigation: {
						nextEl: nextButton,
						prevEl: prevButton,
					},

					pagination: {
						el: paginator,
						clickable: true,
					},

					breakpoints: {
						320: {
							slidesPerView: 1.6,
						},
						576: {
							slidesPerView: 1.6,
						},
						768: {
							slidesPerView: 1.6,
						},
						992: {
							slidesPerView: 1.6,
						},
						// 1400: {
						// 	slidesPerView: perviewSlider,
						// },
					},
				} );

				swiperCarousel.autoplay.stop();

				const playPauseButton = carousel.querySelector(
					'.swiper-button-play-pause'
				);
				if ( playPauseButton ) {
					playPauseButton.addEventListener( 'click', function ( e ) {
						const arialLabel =
							playPauseButton.getAttribute( 'aria-label' );
						if ( arialLabel == 'play' ) {
							swiperCarousel.autoplay.start();
							playPauseButton.setAttribute(
								'aria-label',
								'pause'
							);
						} else {
							swiperCarousel.autoplay.pause();
							playPauseButton.setAttribute(
								'aria-label',
								'play'
							);
						}
					} );
				}
			}
		} );
	}
} );
